// Libaries imports
import { useEffect, useState } from "react";

// Icon imports
import { FaArrowUp } from "react-icons/fa";

function BackToTop() {
  /* -------- Variables -------*/
  const [visible, setVisible] = useState(false);

  /*----- Track the back toggle  ------*/
  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
      return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  /*-------- Functions -------*/
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    visible && (
      <button
        onClick={scrollToTop}
        className="back-to-top"
        aria-label="Back to top"
      >
        <FaArrowUp />
      </button>
    )
  );
}

export default BackToTop;
